import type { TFunction } from 'i18next';
import capitalize from 'lodash-es/capitalize';

import { Member, RoleType } from '@/shared/types/member';
import { NamedRole, Role } from '@/shared/types/role';

import { roleDisplayName } from './systemRoles';

type InvitationRoles = { roles?: NamedRole[]; role_ids?: string[] };

export const getInitials = (name?: string) => {
  if (!name) {
    return '';
  }
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0 || !parts[0]) {
    return '';
  }
  if (parts.length === 1) {
    return parts[0][0]!.toUpperCase();
  }
  return (parts[0][0]! + parts[parts.length - 1]![0]!).toUpperCase();
};

export const getRoleName = (member: Member, roles: Role[]) => {
  if (!member || !roles) {
    return null;
  }
  if (member.role !== RoleType.RBAC) {
    return capitalize(member.role);
  }

  const roleNames = member.role_ids?.map(
    (role_id: string) => roles.find((role) => role.role_id === role_id)?.name
  );
  return roleNames?.join(', ') || '-';
};

export const getInvitationRoleIds = (invitation: InvitationRoles) =>
  invitation.roles?.map((role) => role.role_id) ?? invitation.role_ids ?? [];

export const getInvitationRoleNames = (
  invitation: InvitationRoles,
  t: TFunction,
  accountRoles: Role[] = []
): NamedRole[] => {
  const nameOf = (role_id: string) =>
    accountRoles.find((role) => role.role_id === role_id)?.name ??
    invitation.roles?.find((role) => role.role_id === role_id)?.name ??
    '';

  return getInvitationRoleIds(invitation)
    .map((role_id) => ({ role_id, name: roleDisplayName({ role_id, name: nameOf(role_id) }, t) }))
    .filter((role) => role.name);
};
